import fetch from '@/utils/fetch'

export default {
  actions: {
    async getSrcDict() {
      return await fetch.get('/api/dict/get-list')
    }
  },
}
